import { render, staticRenderFns } from "./ConventionTeaserAlert.vue?vue&type=template&id=5b9d3b39&scoped=true"
import script from "./ConventionTeaserAlert.vue?vue&type=script&lang=js"
export * from "./ConventionTeaserAlert.vue?vue&type=script&lang=js"
import style0 from "./ConventionTeaserAlert.vue?vue&type=style&index=0&id=5b9d3b39&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9d3b39",
  null
  
)

export default component.exports